export const ZexoraLogo = ({ className, props }) => {
  return (
    <>
      <svg viewBox="0 0 320 100" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="ZEXORA logo" role="img" {...props}>
        <text x="10" y="50" fontSize="40" fontWeight="700" fontFamily="Poppins, Arial, sans-serif">
          <tspan fill="#e60023">ZE</tspan>
          <tspan fill="#fefcfc">XORA</tspan>
        </text>
        <text x="12" y="75" fontSize="14" fill="#c1bcbc" fontFamily="Poppins, Arial, sans-serif" letterSpacing="1">
          Smart Study Starts Here
        </text>
      </svg>
    </>
  );
};
